export var loadLocales = function loadLocales(data) {
  return data;
};
export var loadLabels = function loadLabels(data) {
  return data;
};